// eslint-disable-next-line @tseslint/typedef
export const REGISTER_USER_TOKENS = {
  INVALID_REGISTRATION_LINK: "invalid-registration-link",
  REGISTRATION_LINK_EXPIRED: "registration-link-is-expired",
  REGISTRATION_ALREADY_DONE: "user-is-verified"
} as const;
export type RegisterUserToken = typeof REGISTER_USER_TOKENS[keyof typeof REGISTER_USER_TOKENS];

const allowedTokens: string[] = Object.values(REGISTER_USER_TOKENS);

/**
 * Runtime type guard to check if a value is one of the defined RegisterUserTokens literals.
 *
 * @param token – The value to validate.
 * @returns `true` if `token` is exactly one of the RegisterUserTokens strings; otherwise `false`.
 */
export function isRegisterUserResponseToken (token: unknown): token is RegisterUserToken {
  return typeof token === 'string' && allowedTokens.includes(token as RegisterUserToken);
}
